export default {
    methods: {
        __(label) {
            if (MODUL.translations[label]) {
                return MODUL.translations[label]
            }
            return label
        },
    }
}
